import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { DateTime } from "luxon"
import { DateTimeFactory } from "../../../../modules/localization/useDateTime"

export enum DatePeriod {
    ALL = "ALL",
    TODAY = "TODAY",
    TOMORROW = "TOMORROW",
    NEXT_7_DAYS = "7d",
    NEXT_30_DAYS = "30d",
}

type SelectDatePeriodFilterProps = {
    datePeriod: DatePeriod
    setDatePeriod: (val: DatePeriod) => void
    className?: string
}

interface TimePeriodResult {
    start: DateTime
    end: DateTime
}

export const getTimePeriod = (dateTimeFactory: DateTimeFactory, period: DatePeriod): TimePeriodResult => {
    const now = dateTimeFactory.now()

    switch (period) {
        case DatePeriod.TODAY:
            return {
                start: now.startOf("day"),
                end: now.endOf("day"),
            }
        case DatePeriod.TOMORROW:
            return {
                start: now.plus({ days: 1 }).startOf("day"),
                end: now.plus({ days: 1 }).endOf("day"),
            }
        case DatePeriod.NEXT_7_DAYS:
            return {
                start: now.startOf("day"),
                end: now.plus({ days: 7 }).endOf("day"),
            }
        case DatePeriod.NEXT_30_DAYS:
            return {
                start: now.startOf("day"),
                end: now.plus({ days: 30 }).endOf("day"),
            }
        default:
            return {
                start: now.startOf("day"),
                end: now.endOf("day"),
            }
    }
}

export function SelectDatePeriodFilter({ datePeriod, setDatePeriod, className }: SelectDatePeriodFilterProps) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="table-select-date-period-filter-by-label">
                <InputLabel id="pos-table-select-filter-by-date-period">Period</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-date-period-filter-by-label-label" attrs={{ label: true }}>
                <Select
                    labelId="pos-table-select-filter-by-date-period"
                    id="pos-table-filter-by-date-period"
                    value={datePeriod}
                    label="Period"
                    onChange={(e) => setDatePeriod(e.target.value as DatePeriod)}
                    className={className}
                >
                    {Object.values(DatePeriod).map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="table-select-date-period-filter-by" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
